import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {map} from 'rxjs';
import {CommunitiesService} from '../_services/communities.service';

export const userAnswerForCommunityQuestionsGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);
    const communitiesService: CommunitiesService = inject(CommunitiesService);

    return communitiesService.getCurrentDashboardCommunity().pipe(
        map(community => {
            if (!community) {
                return true;
            }

            if ((communitiesService.profileRefreshed as boolean | undefined) !== false || community?.profile_questions_count <= 0) {
                return true;
            }

            router.navigate(['/profile-questions']).then();
            return false;
        })
    )
};
